import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import {
  createEmailServiceValidationForm,
  createUserServiceValidationForm,
} from "../../utils/validationSchemas";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useLocation } from "react-router-dom";
const CreateUser = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createEmailServiceValidationForm),
  });
  const { handleCreate, isLoading, userProfile } = props;
  const location = useLocation();

  return (
    <>
      <form onSubmit={handleSubmit(handleCreate)}>
        <div className={tw`grid grid-cols-2 gap-x-4 mx-4`}>
          <TextField
            label="Username"
            register={register("username")}
            errors={errors?.username}
          />

          <TextField
            label="Full Name"
            register={register("full_name")}
            errors={errors?.full_name}
          />
        </div>

        <div className={tw`flex justify-end mx-4 mt-4`}>
          <button
            type="submit"
            disabled={isLoading}
            className={tw`
        px-4 py-2 rounded
        bg-primary text-white
        disabled:opacity-60
      `}
          >
            {isLoading ? "Creating..." : "Create"}
          </button>
        </div>
      </form>
    </>
  );
};

export default CreateUser;
